@use "~theme/typography";

.label {
  @include typography.caption-semibold;
  display: flex;
  margin-bottom: 12px;
  cursor: pointer;
  user-select: none;
  border: 1px solid var(--blue-02-at-30);
  border-radius: 4px;
  background-color: var(--blue-03);

  &:focus-within {
    border: 1px solid var(--blue-02);
  }
}

.checkboxContainer {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin: 10px 8px;
}

.text {
  padding: 12px;
  border-left: 1px solid var(--blue-02-at-30);
  color: var(--blue-01);

  :focus-within > & {
    border-left: 1px solid var(--blue-02);
  }
}